export default function createInviteActionCodeSettings(deepLink: string) {
  return {
    handleCodeInApp: true,
    url: deepLink, // this is also the web fallback TODO: Make sure this is the route we want on web... need to think about it some more
    iOS: { bundleId: 'com.tophouse.ios' },
    android: {
      packageName: 'com.tophouse',
      installApp: true,
    },
    dynamicLinkDomain: 'tpho.us', // Do not include "https://". See https://firebase.google.com/docs/reference/js/auth.actioncodesettings.md#actioncodesettingsdynamiclinkdomain
  };
}
